<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        销售员分配客户
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;" class="search-box">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">用户电话:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="mobile" clearable size="small" placeholder="用户电话"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">用户姓名:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="nickname" clearable size="small" placeholder="用户姓名"></el-input>
          </el-col>

          <el-col :span="6" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column prop="bind_mobile" width="160" label="用户电话" align="center"></el-table-column>
        <el-table-column label="用户姓名" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.remark_name != ''">{{scope.row.remark_name}}</span>
            <span v-else>{{scope.row.nickname}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pay_sum_money" label="消费金额" align="center"></el-table-column>
        <el-table-column prop="create_date" width="170" label="注册时间" align="center"></el-table-column>
        <el-table-column prop="order_num" label="订单数量" align="center"></el-table-column>
        <el-table-column prop="is_host" label="身份" align="center"></el-table-column>
        <el-table-column label="操作" width="150" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button
              v-if="scope.row.has_mobile!=1"
              @click="allocation(scope.row.mobile)"
              class="button1"
            >
              分配给
              <span style="color:#3498db">{{real_name}}</span>
            </button>
            <span v-else>已分配</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-row>
          <el-col :span="12">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              @current-change="setPage"
            >1</el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'list',
  data() {
    return { serve: this.$store.state.serve,
      serve: this.$store.state.serve,
      token: this.$cookies.get('token'),
      username: this.$cookies.get('username'),
      id: this.$route.params.id,
      page: null,
      total: 0,
      tableData: [],
      mobile: '',
      nickname: '',
      real_name:''
    }
  },
  created() {
    this.$store.state.leftTitle = '管理员列表'
    this.$store.state.topActiveId = 6
    this.geting()
    this.get_real_name(this.$route.params.id)
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection()
      } else {
        this.$refs.multipleTable.clearSelection()
        this.$refs.multipleTable.toggleAllSelection()
      }
    }
  },
  methods: {
    alert_success(message) {
      this.$message({
        type: 'success',
        message: message,
        offset: 200
      })
    },
    alert_error(message) {
      this.$message({
        type: 'error',
        message: message,
        offset: 200
      })
    },
    allocation(mobile) {
      this.$confirm('确定要把此用户分配给销售员？', '分配用户', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定分配',
        cancelButtonText: '再想想'
      })
        .then(() => {
            this.axios
            .get(this.serve + '/admin/username_mobile',{
                params:{
                    username:this.username,
                    token:this.token,
                    id:this.id,
                    mobile:mobile
                }
            }).then(res=>{
                 this.geting();
                var data = res.data
                if(data.status == 'success'){
                    this.alert_success('分配成功!');
                }else{
                    this.alert_error('分配失败!')
                }
               
            })
        })
        .catch(action => {})
    },
    get_real_name(id) {
      this.axios
        .get(this.serve + '/admin/get_real_name', {
          params: {
            username: this.username,
            token: this.token,
            id: id
          }
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.real_name = data.data.real_name
          } else {
            this.real_name = '未知销售员'
          }
        })
    },
    setPage(v) {
      this.page = v
      this.geting(v)
      this.selectAll = false
    },

    geting(page) {
      //请求数据
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var that = this
      this.username = this.$cookies.get('username')
      this.token = this.$cookies.get('token')
      this.axios
        .get(this.serve + '/admin/home_user_list2', {
          params: {
            token: this.token,
            username: this.username,
            mobile: this.mobile,
            nickname: this.nickname,
            page: page ? page : this.page,
            id: this.id
          }
        })
        .then(res => {
          that.tableData = []
          var json = res.data.data
          if (json) {
            that.total = res.data.data.total
            that.page = res.data.data.page
            for (var key in json.results) {
              var time = json.results[key].create_date
              var timeNew = new Date(parseInt(time) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, ' ')
              json.results[key].create_date = timeNew
              if (json.results[key].is_host == '1') {
                json.results[key].is_host = '主账户'
              } else if (json.results[key].is_host == '0') {
                json.results[key].is_host = '普通账户'
              }
              that.tableData.push(json.results[key])
            }
          }
          loading.close()
        })
    }
  }
}
</script>
<style lang="scss">
.list {
    .search-box {
    width: 1054px;
    height: 86px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: 'MicrosoftYaHeiLight';
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search {
    display: flex;
    justify-content: left;
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>